import { render, staticRenderFns } from "./filter-panel.vue?vue&type=template&id=48c63452&scoped=true"
import script from "./filter-panel.vue?vue&type=script&lang=js"
export * from "./filter-panel.vue?vue&type=script&lang=js"
import style0 from "./filter-panel.vue?vue&type=style&index=0&id=48c63452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c63452",
  null
  
)

export default component.exports